export default __webpack_public_path__ + "static/media/brave_zone_background_l2.ff70bfbe.jpg";